import styles from "./styles.module.css";

import React from "react";

import { TimePeriod } from "./../TimePeriod/TimePeriod";

import { useTimePeriod } from "./../../hooks/useTimePeriod/useTimePeriod";

/*
 * вёрска рейсов направления полёта
 */
export const Direction = ({ schedule }) => {
  const [timePeriod, nextTimePeriod, lastTimePeriod] = useTimePeriod();

  // console.log(schedule);
  // console.log(timePeriod);

  // ?<--------------------------------------------------------------------------------------------------------------->

  // название города вылета
  let origincityName = schedule[0]?.flights[0]?.origincityName;
  // название города назначения
  let destinationcityName =
    schedule[0]?.flights[schedule[0]?.flights.length - 1]?.destinationcityName;

  //   оставляем только те рейсы которые попадают в временной периуд
  schedule = schedule.filter((elem) => {
    let beginDate = elem.flights[0].begin_date.split(".");
    beginDate = new Date(beginDate[2], +beginDate[1] - 1, beginDate[0]);

    // дата оканчания ативности расписания
    let endDate = elem.flights[0].end_date.split(".");
    endDate = new Date(endDate[2], +endDate[1] - 1, endDate[0]);

    return (
      beginDate.getTime() <= new Date(timePeriod.finish).getTime() &&
      //   endDate.getTime() >= new Date(timePeriod.finish).getTime() &&
      endDate.getTime() >= new Date(timePeriod.statr).getTime()
    );
  });

  // ?<--------------------------------------------------------------------------------------------------------------->

  let row = schedule.map((elem) => {
    let week = timePeriod?.week?.map((weekElem) => {
      let url = new URL("https://booking.sila-avia.ru/websky/");
      url.searchParams.set("lang", "ru");
      url.searchParams.set("segmentsCount", 1);
      url.searchParams.set("searchPeriod", 0);
      url.searchParams.set("direct-only", 0);
      url.searchParams.set("origin-city-code[0]", elem.flights[0].origincity);
      url.searchParams.set(
        "destination-city-code[0]",
        elem.flights[0].destinationcity
      );
      url.searchParams.set("date[0]", weekElem.date);
      url.searchParams.set("adultsCoun", 1);
      url.searchParams.set("childrenCount", 0);
      url.searchParams.set("infantsWithSeatCount", 0);
      url.searchParams.set("infantsWithoutSeatCount", 0);

      let title = weekElem.date;

      let active = elem.flights[0].dates.includes(weekElem.date)
        ? styles.active
        : "";

      let name = elem.flights[0].dates.includes(weekElem.date) ? (
        <a href={url.href} title={title} target="_blank">
          {weekElem.name}
        </a>
      ) : (
        weekElem.name
      );

      return <td className={styles.DayWeek + ` ${active}`}>{name}</td>;
    });

    // рейсы
    let flights = elem.flights.map((itemFlight, i) => {
      let connections = <></>;

      if (elem.connections !== undefined && elem.connections[i] !== undefined) {
        connections = (
          <tr>
            <td colSpan="7">
              <div className={styles.connections}>
                {`Пересадка: ${elem.connections[i].cityName}`}
              </div>
            </td>
          </tr>
        );
      }

      return (
        <>
          <tr>
            <td colSpan="7">
              <div className={styles.flight_data}>
                {/* рейс */}
                <span>{itemFlight.racenumber}</span>
                {/* время */}
                <span>
                  {itemFlight.departuretime} - {itemFlight.arrivaltime}
                </span>
                {/* длительность */}
                <span>{itemFlight.flightTime}</span>
              </div>
            </td>
          </tr>
          {connections}
        </>
      );
    });

    return (
      <>
        {flights}
        <tr>{week}</tr>
      </>
    );
  });

  if (schedule.length === 0)
    row = (
      <tr>
        <td>расписание отсутствует</td>
      </tr>
    );

  // ?<--------------------------------------------------------------------------------------------------------------->

  return (
    <>
      <div className={styles.title}>
        <h2>
          {origincityName} &#8594; {destinationcityName}
        </h2>
        <TimePeriod
          timePeriod={timePeriod}
          nextTimePeriod={nextTimePeriod}
          lastTimePeriod={lastTimePeriod}
        />
      </div>

      <table className={styles.table}>
        <tbody>{row}</tbody>
      </table>
    </>
  );
};
